
const state = {
    notifications: [],
    loading: false,
    unreadCount: 0,
    preferences: [],
    notificationTypes: {
        NEW_QUESTION: "Nová otázka",
        DISCUSSION_REPLY: "Reakcia v diskusii",
        SYSTEM: "Systémová správa",
        ADMIN_IMPORTANT: "Dôležité"
    }
};

import { APIService } from "@/http/APIService";
const apiService = new APIService();

const getters = {
    getNotifications: (state) => state.notifications,
    getUnreadCount: (state) => state.unreadCount,
    getPreferences: (state) => state.preferences,
    isLoading: (state) => state.loading,
    getNotificationTypes: (state) => state.notificationTypes
};

const actions = {
    async fetchNotifications({ commit, rootGetters }, { page = 1, unread = null, type = null }) {
        if (!rootGetters['auth/isAuthenticated']) {
            commit('setNotifications', []);
            commit('setLoading', false);
            return;
        }
        commit('setLoading', true);
        try {
            const data = await apiService.getNotifications(page, unread, type);
            // If page 1, replace. If > 1, append? For now let's just replace or handle pagination in component
            // But let's follow standard pattern, usually we just set what we got
            commit('setNotifications', data);
        } catch (error) {
            console.error(error);
        } finally {
            commit('setLoading', false);
        }
    },

    async fetchUnreadCount({ commit, rootGetters }) {
        if (!rootGetters['auth/isAuthenticated']) {
            commit('setUnreadCount', 0);
            return;
        }
        try {
            const data = await apiService.getUnreadNotificationCount();
            commit('setUnreadCount', data.unread_count);
        } catch (error) {
            console.error(error);
        }
    },

    async markAsRead({ commit, dispatch }, id) {
        try {
            await apiService.markNotificationRead(id);
            // Optimistic update or refetch? Refetch is safer for count sync
            commit('markReadLocally', id);
            dispatch('fetchUnreadCount');
        } catch (error) {
            console.error(error);
        }
    },

    async markAllAsRead({ commit, dispatch }) {
        try {
            await apiService.markAllNotificationsRead();
            commit('markAllReadLocally');
            dispatch('fetchUnreadCount');
        } catch (error) {
            console.error(error);
        }
    },

    async fetchPreferences({ commit, rootGetters }) {
        if (!rootGetters['auth/isAuthenticated']) {
            commit('setPreferences', []);
            return;
        }
        try {
            const data = await apiService.getNotificationPreferences();
            if (data.results) {
                commit('setPreferences', data.results);
            } else {
                commit('setPreferences', data);
            }
        } catch (error) {
            console.error(error);
        }
    },

    async deletePreference({ dispatch }, id) {
        try {
            await apiService.deletePreference(id);
            dispatch('fetchPreferences');
        } catch (error) {
            console.error(error);
        }
    }
};

const mutations = {
    setNotifications(state, data) {
        state.notifications = data;
    },
    setLoading(state, status) {
        state.loading = status;
    },
    setUnreadCount(state, count) {
        state.unreadCount = count;
    },
    setPreferences(state, data) {
        state.preferences = data;
    },
    markReadLocally(state, id) {
        // Find notification and mark as read
        if (state.notifications.results) {
            const notif = state.notifications.results.find(n => n.id === id);
            if (notif) {
                notif.read_at = new Date().toISOString();
                notif.is_unread = false;
            }
        }
    },
    markAllReadLocally(state) {
        if (state.notifications.results) {
            state.notifications.results.forEach(n => {
                n.read_at = new Date().toISOString();
                n.is_unread = false;
            });
        }
        state.unreadCount = 0;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
